module.exports = __webpack_public_path__ + "static/media/tags.7322d6fd.svg";